import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const LimitReachedPage = () => {
    const location = useLocation();
    const { resource } = location.state || { resource: 'items' }; // Default resource name

    const resourceText = {
        recruiters: 'Recruiters',
        active_jobs: 'Active Jobs',
        candidates: 'Candidates',
        default: 'items'
    };

    const currentResource = resourceText[resource] || resourceText.default;

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="w-full max-w-lg p-8 space-y-8 bg-white rounded-2xl shadow-lg text-center">
                <div className="flex justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <h1 className="text-3xl font-bold text-gray-900">You've Reached Your Plan's Limit</h1>
                <p className="text-lg text-gray-600">
                    You have reached the maximum number of <span className="font-semibold">{currentResource}</span> allowed on your current plan.
                </p>
                <p className="text-md text-gray-500">
                    To increase your limits, please upgrade your plan or contact our team for more options.
                </p>
                <div className="flex justify-center space-x-4 pt-4">
                    <Link to="/pricing" className="px-6 py-3 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                        View Plans & Pricing
                    </Link>
                    <Link to="/contact-support" className="px-6 py-3 text-sm font-semibold text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                        Contact Support
                    </Link>
                </div>
                <div className="pt-6">
                    <Link to="/dashboard" className="text-sm font-medium text-blue-600 hover:underline">
                        &larr; Back to Dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default LimitReachedPage;
